import { useMutation } from "@faire/web-api--source/api/v2/addresses/validate-phone-number/post-hooks";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { useCallback, useRef, useState } from "react";

export const usePhoneNumberValidator = () => {
  const { mutateAsync } = useMutation();
  const lastValidatingPhoneNumber = useRef<string | undefined>(undefined);
  const [isPending, setIsPending] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const validatePhoneNumber = useCallback(
    async (phoneNumber: string, country?: string) => {
      lastValidatingPhoneNumber.current = phoneNumber;
      setIsPending(true);
      if (phoneNumber.trim().length === 0) {
        setIsInvalid(true);
      } else {
        const res = await mutateAsync([
          {
            phone_number: phoneNumber,
            country: country
              ? ISO3166Alpha3[country as keyof typeof ISO3166Alpha3]
              : undefined,
          },
        ]);
        setIsInvalid(!res.is_valid);
      }
      setIsPending(false);
    },
    [mutateAsync]
  );
  const isPhoneNumberInvalid = useCallback(
    (phoneNumber: string) => {
      return (
        lastValidatingPhoneNumber.current &&
        phoneNumber.localeCompare(lastValidatingPhoneNumber.current) === 0 &&
        isInvalid
      );
    },
    [lastValidatingPhoneNumber, isInvalid]
  );
  return {
    isPending,
    isInvalid,
    validatePhoneNumber,
    isPhoneNumberInvalid,
  };
};
